import * as React from 'react';

import SocialLoginButton from './SocialLoginButton';

import TwitterIcon from '../../icons/TwitterIcon';

import {colors} from '../../../../styles/variables';

import TwitterLogin, {
  ErrorData,
  SuccessData,
} from '../../../../../domain/services/social_logins/TwitterLogin';

import {isSafari} from '../../../../../data/data_stores/net/UserAgent';

export interface Props {
  onSuccess: (data: SuccessData) => void;
  onError: (error: ErrorData) => void;
  children?: React.ReactNode;
}

export default class TwitterLoginButton extends React.PureComponent<Props> {
  public async componentDidMount() {
    if (isSafari) {
      new TwitterLogin().getRequestToken();
    }
  }

  public render(): React.ReactNode {
    return (
      <SocialLoginButton color={'#efefef'} onPress={this.handlePress}>
        <TwitterIcon color={colors.twitter} />
      </SocialLoginButton>
    );
  }

  private handlePress = () => {
    const {onSuccess, onError} = this.props;
    new TwitterLogin().login({onError, onSuccess});
  };
}
